import { useEffect, useState } from "react";
import { Col, Form, Row } from "antd";
import { FormBox, InputBox } from "../../../../../components/AntdAddons";
import { formRules } from "../../../../../config/validations/formRules";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../utils/hooks/hooks";
import { AppDispatch, RootState } from "../../../../../store/app";
import { validations } from "../../../../../config/validations/validations";
import {
  fetchCareercategory,
  fetchCareerPath,
  fetchOccupationalGroups,
  fetchSkillCategory,
  setCareerPath,
} from "../../../../../store/CommonSlice";
import { MinusCircleOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { fetchIndustryWizeData } from "../../../Industry/utils/slice";
import { fetchIndustryList } from "../../../Industry/utils/slice";

import { INDUSTRY_FILTER } from "../../../../../config/Constant";
import React from "react";
/**
 * Renders a form component for interest discovery.
 *
 * @param {Object} props - The component props.
 * @param {Object} props.form - The form object.
 * @param {string} props.id - The ID of the form.
 * @param {Function} props.handleSubmit - The function to handle form submission.
 * @param {Function} props.onValuesChange - The function to handle form value changes.
 * 
 * @return {JSX.Element} The rendered form component.
 */
const FormComponent: React.FC<any> = ({
  form,
  id,
  handleSubmit,
  onValuesChange,
  editValues,
  ...rest
}) => {
  const dispatch: AppDispatch = useAppDispatch();

  const userDinterestDiscoveryetail: any = useAppSelector(
    (state: RootState) => state.auth.initialData
  );
 

  const [industryList, setIndustryList] = useState<any>([]);
  const [careerPath, setCareerPath] = useState<any>([]);
  const [skillCategory, setSkillCategory] = useState<any>([]);
  const [Ocupationalgroups, setOcupationalgroups] = useState<any>([]);
  const [CareerCategory, setCareerCategory] = useState<any>([]);


  useEffect(() => {
   
    dispatch(fetchIndustryList())
      .then((data: any) => {
        setIndustryList(data.rows);
      })
      .catch((error: any) => error);
  }, []);

  useEffect(() => {
    form.setFieldValue("type", typeObject[0].id);
    if (editValues) {
      form.setFieldsValue(editValues);

      if (editValues.type == 1) {
        const careerCategoriesValues: any = [];
        const occupationalGroupValues: any = [];
        const answerDataArray = editValues?.weightages;
        answerDataArray.forEach((data: any) => {
          if (data?.career_level === 1) {
            careerCategoriesValues.push(data.parent_id);
          }
          if (data?.career_level === 2) {
            occupationalGroupValues.push(data.parent_id);
          }
        });
        form.setFieldsValue({
          [`career_categories`]: careerCategoriesValues,
          [`occupational_group`]: occupationalGroupValues,
        });
      } else {
        const weightages = editValues?.weightages.map((data: any) => {
          return {
            career_categories: data.career_category,
            occupational_group: data.occupational_group,
            career_path: data.career_path,
            skill_category: data.skill_category,
          };
        });
        form.setFieldsValue({
          ["mapping"]: weightages,
        });
      }

      onIndustryChange(editValues.industry_id,false);
    }
  }, [editValues, form]);

  const onFinish = (data: any) => {
    if (data.type === 2) {
      const mapping: any = [];
      Object.entries(data.mapping).forEach(([key, value]: [string, any]) => {
        if (
          value.career_categories ||
          value.skill_category ||
          value.career_path ||
          value.occupational_group
        ) {
          key;
          mapping.push(value);
        }
      });
      data.mapping = mapping;
    }
    else
    {
      data.career_categories = data.career_categories!=null ? data.career_categories : []
      data.occupational_group = data.occupational_group!=null ? data.occupational_group : []
    }

    handleSubmit(data);
  };

  // modify dropdown data for type field
  const typeObject = userDinterestDiscoveryetail?.interest_assessment_type?.map(
    (item: any) => {
      return {
        id: Number(item.id),
        name: item.title,
      };
    }
  );

  const onIndustryChange = (id: number,resetVal= true) => {
    if(resetVal)
    {
      form.setFieldsValue({
      career_categories:null,
      occupational_group:null,
    });

    form.setFieldsValue({
      ["mapping"]: [],
    });
    

    }
    dispatch(fetchIndustryWizeData([id], [
      INDUSTRY_FILTER.CAREER_CATEGORY,
      INDUSTRY_FILTER.SKILL_CATEGORY,
      INDUSTRY_FILTER.OCCUPATIONAL_GROUP,
      INDUSTRY_FILTER.CAREER_PATH,
    ]))
      .then((response: any) => {
        // setCareerCategory(response.data.career_category);
        setCareerCategory(response.data.career_category.map((item: any) => {
            item.name = `${item.code} - ${item.name}`
            return item;
          }));
        // setSkillCategory(response.data.skill_category);
        setSkillCategory(response.data.skill_category.map((item: any) => {
            item.name = `${item.code} - ${item.name}`
            return item;
          }));
        setOcupationalgroups(response.data.occupational_group);
        setCareerPath(response.data.career_path);
      })
      .catch((error: any) => error);
  }

  return (
    <>
      <FormBox
        form={form}
        id={id}
        onFinish={onFinish}
        onValuesChange={onValuesChange}
        {...rest}
      >
        <Row gutter={15}>
          <Col xs={{ span: 24 }} md={{ span: 24 }}>
            <InputBox.Select
              label="Type"
              name="type"
              className="singleSelect"
              showSearch
              optionFilterProp="children"
              filterOption={(input, option: any) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              options={{
                list: typeObject,
                valueKey: "id",
                textKey: "name",
              }}
              rules={[validations.required.select()]}
            />
          </Col>
        </Row>
        <Row gutter={15}>
          <Col xs={{ span: 24 }} md={{ span: 24 }}>
            <InputBox.Text
              name="question"
              label="Question"
              rules={formRules.custom({ max: 255 })}
            />
          </Col>
        </Row>
        <Row gutter={15}>
          <Col xs={{ span: 24 }} md={{ span: 24 }}>
            <InputBox.Text
              name="code"
              label="Code"
              rules={formRules.custom({ max: 255 })}
            />
          </Col>
        </Row>
        <Col xs={{ span: 24 }} md={{ span: 24 }} >
          <InputBox.Select
            required
            label="Industry Name"
            name="industry_id"
            showSearch
            className="singleSelect"
            optionFilterProp="children"
            filterOption={(input, option: any) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >=
              0
            }
            onChange={(val) => onIndustryChange(val)}
            options={{
              list: industryList,
              valueKey: "id",
              textKey: "industry_name",
              // disabled:true
            }}
          />

        </Col>
        <Row gutter={15}>
          <Form.Item
            noStyle
            shouldUpdate={(prevValues, currentValues) =>
              prevValues?.type !== currentValues?.type
            }
          >
            {({ getFieldValue }) =>
              getFieldValue("type") == 1 && (
                <>
                  <Col xs={{ span: 4 }} md={{ span: 6 }} className="skillItem">
                    <InputBox.Select
                      required
                      name={`career_categories`}
                      label="Career Categories"
                      optionFilterProp="children"
                      showSearch
                      filterOption={(input, option: any) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      options={{
                        list: CareerCategory,
                        valueKey: "id",
                        textKey: "name",
                      }}
                      mode="multiple"
                    />
                  </Col>
                  <Col xs={{ span: 4 }} md={{ span: 6 }} className="skillItem">
                    <InputBox.Select
                      required
                      name={`occupational_group`}
                      label="Occupational Groups"
                      optionFilterProp="children"
                      showSearch
                      filterOption={(input, option: any) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      options={{
                        list: Ocupationalgroups,
                        valueKey: "id",
                        textKey: "name",
                      }}
                      mode="multiple"
                    />
                  </Col>
                </>
              )
            }
          </Form.Item>
        </Row>
        <Form.Item
          noStyle
          shouldUpdate={(prevValues, currentValues) =>
            prevValues?.type !== currentValues?.type
          }
        >
          {({ getFieldValue }) =>
            getFieldValue("type") == 2 && (
              <>
                <Form.List name="mapping">
                  {(fields, { add, remove }) => {
                    const myFields = fields.length
                      ? fields
                      : [
                        {
                          name: 0,
                          key: 0,
                          isListField: true,
                          fieldKey: 0,
                        },
                      ];
                    return (
                      <>
                        {myFields.map(({ key, name, ...restField }) => (
                          <Row key={key} gutter={15}>
                            <Col
                              xs={{ span: 1 }}
                              md={{ span: 1 }}
                              className="skillItem"
                            >
                              {" "}
                              {name + 1}.
                            </Col>
                            <Col
                              xs={{ span: 4 }}
                              md={{ span: 5 }}
                              className="skillItem"
                            >
                              <InputBox.Select
                                required
                                name={[name, `career_categories`]}
                                label={`Career Category`}
                                optionFilterProp="children"
                                className="singleSelect"
                                {...restField}
                                showSearch
                                filterOption={(input, option: any) =>
                                  option.children
                                    .toLowerCase()
                                    .indexOf(input.toLowerCase()) >= 0
                                }
                                options={{
                                  list: CareerCategory,
                                  valueKey: "id",
                                  textKey: "name",
                                }}
                              />
                            </Col>
                            <Col
                              xs={{ span: 4 }}
                              md={{ span: 5 }}
                              className="skillItem"
                            >
                              <InputBox.Select
                                required
                                name={[name, `occupational_group`]}
                                label={`Occupational Group`}
                                className="singleSelect"
                                optionFilterProp="children"
                                {...restField}
                                showSearch
                                filterOption={(input, option: any) =>
                                  option.children
                                    .toLowerCase()
                                    .indexOf(input.toLowerCase()) >= 0
                                }
                                options={{
                                  list: Ocupationalgroups,
                                  valueKey: "id",
                                  textKey: "name",
                                }}
                              />
                            </Col>
                            <Col
                              className="skillItem"
                              xs={{ span: 4 }}
                              md={{ span: 5 }}
                            >
                              <InputBox.Select
                                required
                                name={[name, `career_path`]}
                                label={`Career Path`}
                                className="singleSelect"
                                showSearch
                                optionFilterProp="children"
                                {...restField}
                                filterOption={(input, option: any) =>
                                  option.children
                                    .toLowerCase()
                                    .indexOf(input.toLowerCase()) >= 0
                                }
                                options={{
                                  list: careerPath,
                                  valueKey: "id",
                                  textKey: "name",
                                }}
                              />
                            </Col>
                            <Col
                              className="skillItem"
                              xs={{ span: 4 }}
                              md={{ span: 5 }}
                            >
                              <InputBox.Select
                                required
                                name={[name, `skill_category`]}
                                label={`Skill Category`}
                                className="singleSelect"
                                {...restField}
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, option: any) =>
                                  option.children
                                    .toLowerCase()
                                    .indexOf(input.toLowerCase()) >= 0
                                }
                                options={{
                                  list: skillCategory,
                                  valueKey: "id",
                                  textKey: "name",
                                }}
                              />
                            </Col>
                            <Col
                              xs={{ span: 24 }}
                              md={{ span: 3 }}
                              className="addRemove"
                            >
                              {id !== "viewForm" && (
                                <MinusCircleOutlined
                                  onClick={() => {
                                    remove(name);
                                  }}
                                />
                              )}
                              {id !== "viewForm" &&
                                myFields.length - 1 === name && (
                                  <PlusCircleOutlined
                                    onClick={() => {
                                      add();
                                    }}
                                  />
                                )}
                            </Col>
                            {myFields.length - 1 !== name && <hr />}
                          </Row>
                        ))}
                      </>
                    );
                  }}
                </Form.List>
              </>
            )
          }
        </Form.Item>
      </FormBox>
    </>
  );
};

export default FormComponent;
